var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.category'] = (function () {
    'use strict';

    const CONFIG = {
        COMPARE_SELECTOR: ".widget-category__compare",
        COMPARE_CONTROLS_SELECTOR: ".widget-category__compare__controls",
        COMPARE_CHECKBOX_SELECTOR: ".form-check-input",
        BREAKPOINTS: ["enter-xs", "enter-sm", "enter-md", "enter-lg", "enter-xl", "enter-xxl"]
    };

    const initialize = (widget) => {

        const compareEl = widget.querySelector(CONFIG.COMPARE_SELECTOR);
        const compareControlsEl = widget.querySelector(CONFIG.COMPARE_CONTROLS_SELECTOR);
        if (!compareEl || !compareControlsEl) return;

        // Bind change events to all compare checkboxes to update UI on selection.
        const checkboxes = compareControlsEl.querySelectorAll(CONFIG.COMPARE_CHECKBOX_SELECTOR);
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener("change", () => {
                updateCompareUI(compareEl, compareControlsEl);
            });
        });

        // Bind breakpoint change events to reset checkbox state responsively.
        CONFIG.BREAKPOINTS.forEach(bp => {
            document.addEventListener(bp, () => {
                setCheckboxStates(compareEl,compareControlsEl);
            });
        });

        setCheckboxStates(compareEl, compareControlsEl);
    };

    // Set checked/disabled states for compare checkboxes
    const setCheckboxStates = (compareEl, compareControlsEl) => {

        const checkboxes = compareControlsEl.querySelectorAll(CONFIG.COMPARE_CHECKBOX_SELECTOR);
        const selectionLimits = getCompareSelectionLimits();

        // Reset checkboxes
        for (const checkbox of checkboxes) {
            checkbox.checked = false;
            checkbox.disabled = false;
        }

        // Check first N allowed by breakpoint using index-based loop
        for (let i = 0; i < selectionLimits.max && i < checkboxes.length; i++) {
            checkboxes[i].checked = true;
        }

        // Show or hide control panel
        compareControlsEl.style.display = checkboxes.length <= selectionLimits.max ? "none" : "";
        updateCompareUI(compareEl, compareControlsEl, selectionLimits);
    };

    /* ==========================================================================
    UI Synchronization
    ========================================================================== */
    const updateCompareUI = (compareEl, compareControlsEl, selectionLimits) => {

        // Synchronize UI: enforce min/max limits and show/hide controlled columns.
        const checkboxes = compareControlsEl.querySelectorAll(CONFIG.COMPARE_CHECKBOX_SELECTOR);
        selectionLimits = selectionLimits || getCompareSelectionLimits();

        const checkedInfo = countCheckedCheckboxes(checkboxes);
        const checkedCount = checkedInfo.checkedCount;
        const activeCheckboxIds = checkedInfo.activeCheckboxIds;

        // Enforce min/max limits
        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                checkbox.disabled = checkedCount <= selectionLimits.min;
            }
            else {
                checkbox.disabled = checkedCount >= selectionLimits.max;
            }
        }

        // Update controlled columns
        const controlledColumns = compareEl.querySelectorAll("[data-controlledby]");
        for (const column of controlledColumns) {
            const controllingId = column.getAttribute("data-controlledby");
            column.style.display = activeCheckboxIds.indexOf(controllingId) !== -1 ? "" : "none";
        }
    };

    /* ==========================================================================
    Helpers
    ========================================================================== */

    // Count checked checkboxes and collect their IDs for UI sync.
    const countCheckedCheckboxes = checkboxes => {

        let checkedCount = 0;
        const activeCheckboxIds = [];

        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                checkedCount++;
                activeCheckboxIds.push(checkbox.id);
            }
        }
        return { checkedCount, activeCheckboxIds };
    };

    // Get min/max selection limits based on current breakpoint.
    const getCompareSelectionLimits = () => {

        switch (App.ZagBreakpoints.getBreakpoint()) {
            case 'xxl':
            case 'xl': return { max: 4, min: 2 };
            case 'lg':
            case 'md': return { max: 3, min: 2 };
            default: return { max: 2, min: 1 };
        }
    };

    return {
        initialize
    };

})();